<template>
    <NGramFlow />
</template>

<script lang="ts" setup>
import NGramFlow from '@/components/toolkit/ngram/NGramFlow.vue'
</script>
